import { FaqService } from 'src/app/services/faq-services/faq.service';
import { Component, Input } from '@angular/core';
import { LocalStorageService } from '../services/localstorage-service/localstorage-service';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { get } from 'http';
import { formatDate } from '@angular/common';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityServiceService } from '../services/utility-services/utility-service.service';

@Component({
  selector: 'app-aiknowledgebase',
  templateUrl: './aiknowledgebase.component.html',
  styleUrls: ['./aiknowledgebase.component.scss']
})
export class AiknowledgebaseComponent {
  like;
  dislike;
  answerbyid:any;
  likestatus:any;
  cardDetails: any;
  emailContent: string = "";
  username:any;
  emailFormData: FormGroup;
  @Input() componentContext;
  @Input() selectionType:any;
  dislikeForm: FormGroup;
  dislikeFormArray: FormArray;
  required = false;
  reason_array = [];
  toEmails: string = "";
  submitted = false;
  dislikePayload: any = {};
  likePayload: any = {};
  user:any;
  sendMailData: any = {};
  emailFormSubmitted = false;
  emailtexttoggle:boolean=false;
  mutlipleemail:boolean=false;
  tcontainer1 = {
    height: (($(window).height() - $('.layout-navbar').height()) - 450) + 'px',
   overflow:scroll
  };
  constructor(private faqservice:FaqService, private localStorageService: LocalStorageService,private formBuilder: FormBuilder,private modalService: NgbModal, private utilityService: UtilityServiceService,)
  {

  }
  ngOnInit()
  {this.selectionType=this.faqservice.answerid;
    console.log("componentContext",this.componentContext);
    this.getDetailsByArticleID(this.faqservice.answerid);
    this.utilityService.getUser().subscribe((data: any) => {
      console.log(data);
      this.user = data;
      this.toEmails=( this.user)? this.user.email:'';
  });
    this.dislikeForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      email: ['', [Validators.required,this.emailValidator()]],
      reason: this.formBuilder.array([],Validators.required),
      comment: [''],
      notifyme: [''],
      phone: ['', [Validators.required,Validators.minLength(14)]]
  });
  this.dislikeFormArray = this.dislikeForm.get('reason') as FormArray;

  this.emailFormData = this.formBuilder.group({
      toaddr: ['', Validators.required],
      ccaddr:[''],
      subject: ['', Validators.required],
      emailmsg: ['', Validators.required]
  });
  this.emailFormData.patchValue({
      toaddr: this.toEmails,
      //emailmsg: this.emailContent
  });
  }
  emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailValue = control.value;
      if (emailValue && emailValue.trim() !== '') {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailPattern.test(emailValue) ? null : { invalidEmail: true };
      }
      return null; // No email provided, no error
    };
  }
  ngAfterViewInit() {
    console.log('selectionType ', this.selectionType);

}
getDetailsByArticleID(id: number) {
  this.required = true;
   this.faqservice.article(id).subscribe(
       (article:any) => {
           this.like=false;
           this.dislike = false;
           this.answerbyid=article;
           this.likestatus=article;
           console.log(this.answerbyid)
           this.cardDetails = article.answerlist[0];

           // console.log(this.cardDetails[0].answeridobject.description)
          //  if(this.selectionType == 'help' || this.selectionType == 'training') {
          //      if(this.togglehelp == false) {
          //          this.togglehelp = true;
          //          this.addTab(this.cardDetails.answerid, this.cardDetails.id, this.cardDetails.answeridobject.description);
          //      }
          //  }
           this.emailContent=this.cardDetails.answeridobject.solution;
           this.stripHtmlAndEntities(this.emailContent);
           this.username=JSON.parse(this.localStorageService.get('currentUser')).email;
           console.log(this.username)

           this.emailFormData.patchValue({
               toaddr: this.username,
               emailmsg: this.stripHtmlAndEntities(this.emailContent)
           });

           // console.log('options ', this.cardDetails.likeStatus.options);
           console.log(this.cardDetails);
           // this.downloadFile(article.pdfurl.toString().trim()).subscribe(
           //   (res) => {
           //     this.pdfViewerFaq.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
           //     this.pdfViewerFaq.refresh();
           //   }
           // );
           if(this.answerbyid.likestatus) {
             this.reasonArray();
             this.clearFormArray(this.dislikeFormArray);
             for(let i in this.answerbyid.likestatus.options) {
                 this.required = false;
                 this.reason_array[this.answerbyid.likestatus.options[i]-1].checked = true;
                 this.dislikeFormArray.push(new FormControl(this.answerbyid.likestatus.options[i]));
             }
             if(this.answerbyid.likestatus.flike) {
                 this.like=true;
                 this.dislike = false;
             } else {
                 this.dislike=true;
                 this.like = false;
             }
         }
           //   if(article.likestatus) {
           //     console.log("hy")
           //     this.reasonArray();
           //     this.clearFormArray(this.dislikeFormArray);
           //     // for(article.likeStatus.flike) {
           //     //     this.required = false;
           //     //     this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
           //     //     this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
           //     // }
           //     if(article.likestatus.flike) {
           //         this.like=true;
           //         this.dislike = false;
           //     } else {
           //         this.dislike=true;
           //         this.like = false;
           //     }
           // }
       }
   )
}
 stripHtmlAndEntities(htmlString: string): string {
  if (!htmlString) return '';

  // Remove HTML tags
  const withoutTags = htmlString.replace(/<[^>]*>/g, '');
  const trimmedString = withoutTags.trim().replace(/^"/, '').replace(/"$/, '');
  // Remove &nbsp; entities
  const withoutEntities = trimmedString.replace(/&nbsp;/g, ' ');

  // Remove quotation marks
  const withoutQuotationMarks = withoutEntities.replace(/"/g, '');

  // Split content into words
  const words = withoutQuotationMarks.split(' ');

  // Check if content exceeds 100 words
  if (words.length > 100) {
    return words.slice(0, 100).join(' ') + '...'; // Add ellipsis after 100 words
  } else {
    return withoutQuotationMarks;
  }
}
setReason() {
  $(".sidenav-link").removeClass("active");
  $("#sub_menu_sidenav_bar").addClass("open");
  if(this.selectionType == "help") {
      $("#help-tab").addClass("active");
  } else if(this.selectionType=="training") {
      $("#training-tab").addClass("active");
  } else if(this.selectionType=="aifaq"){
      $("#faq-tabs").addClass("active");
  }

  // this.componentSelectionEmitter({
  //     id: 'faq',
  //     name: 'FAQ',
  //     type: 'faq'
  // });
 this.reasonArray();
}
onSubmit() {
  this.submitted = true; // Indicate that the form has been submitted.

  if(this.dislikeForm.invalid) {
    return; // Prevent submission
  }
  else if(this.dislikeForm.valid) {
    // this.utilityService.checkLogin();
console.log("in onsubmit")
    this.submitted = true;
    if (this.dislikeForm.value.notifyme) {
        this.dislikeForm.controls['email'].setValidators([Validators.required, this.emailValidator()]);
        this.dislikeForm.controls['email'].updateValueAndValidity();
    } else {
        this.dislikeForm.controls['email'].setValidators([this.emailValidator()]);
        this.dislikeForm.controls['email'].updateValueAndValidity();
    }
    if (this.dislikeForm.invalid || this.required) {
        return;
    }
    this.dislikePayload.answerid = this.cardDetails.id;
    console.log(this.dislikePayload.answerid)
    // this.dislikePayload.commentby = this.user.lastname;
    this.dislikePayload.commentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.dislikePayload.comments = this.dislikeForm.value.comment;

    this.dislikePayload.firstname = this.dislikeForm.value.firstName;
    this.dislikePayload.lastname = this.dislikeForm.value.lastName;
    this.dislikePayload.phone = this.dislikeForm.value.phone;
    this.dislikePayload.email = this.dislikeForm.value.email;
    this.dislikePayload.notifyme = this.dislikeForm.value.notifyme;
    this.dislikePayload.flike = false;
    // this.dislikePayload.id = this.cardDetails.likeStatus != null ? this.cardDetails.likeStatus.id : '';

    this.dislikePayload.options = this.dislikeForm.value.reason;
    console.log('dislike payload ', this.dislikePayload);

    this.faqservice.dislikeArticle(this.dislikePayload).subscribe((data: any) => {
        console.log(data);
        if (data!=null) {
            this.dislike=true;
            this.like=false;
            this.cardDetails.likeStatus = data;
            if(data.likeStatus) {
                this.reasonArray();
                this.clearFormArray(this.dislikeFormArray);
                console.log(this.dislikeFormArray);
                for(let i in data.likeStatus.options) {
                    console.log('inside for');
                    this.required = false;
                    this.reason_array[data.likeStatus.options[i]-1].checked = true;
                    this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
                }
            }
            console.log(this.reason_array);
            this.dislikeForm.patchValue({
                firstName: data.likeStatus? data.likeStatus.firstname: this.user.firstname,
                lastName: data.likeStatus? data.likeStatus.lastname: this.user.lastname,
                email: data.likeStatus? data.likeStatus.email: this.user.email,
                // reason:  this.cardDetails.likeStatus.options,
                comment: data.likeStatus?data.likeStatus.comments:'',
                notifyme: data.likeStatus?data.likeStatus.notifyme:'',
                phone: data.likeStatus?data.likeStatus.phone:''
            });
            this.getDetailsByArticleID(this.cardDetails.id);
            $("#dislikeModal"+this.selectionType + " .close").trigger("click");
            $("#dislike_thanks"+this.selectionType).trigger("click");

            this.resetUnlikeForm();

            setTimeout(function() {
                $("#dislikeSentModal .close").trigger("click");
            }, 500);
        }
    });
  }
}
reasonArray() {
  this.reason_array = [{
      id: "1",
      name: "Incorrect Information",
      checked: false,
      control: "incorrect"
  },
  {
      id: "2",
      name: "Irrelevant Information",
      checked: false,
      control: "irrelevant"
  },
  {
      id: "3",
      name: "Duplicate Information",
      checked: false,
      control: "duplicate"
  },
  {
      id: "4",
      name: "Outdated Information",
      checked: false,
      control: "outdated"
  },
  {
      id: "5",
      name: "Other",
      checked: false,
      control: "other"
  }
  ];
  console.log(this.reason_array);
}
clearFormArray = (formArray: FormArray) => {
  while (formArray.length !== 0) {
    formArray.removeAt(0)
  }
}
printPage() {
  window.print();
      }
      getArticleFileName(file) {
        // this.fileName = file.substring(file.lastIndexOf('/') + 1);
        console.log(this.cardDetails);
        console.log(this.cardDetails.description);
        this.emailFormData.patchValue({
            subject: this.cardDetails.ansid + ": " + this.cardDetails.answeridobject.description.replace(/<p>|<\/p>|"/g, '')
        });
    }
    dislikeClick() {
      console.log(this.cardDetails);
      this.submitted = false;

      // this.getDetailsByArticleID(this.cardDetails.id);
      // setTimeout(() => {
          if(this.like) {
              this.reasonArray();
              this.clearFormArray(this.dislikeFormArray);
              console.log(this.cardDetails)
              // this.dislikeReasons = this.cardDetails.likeStatus.options;
             console.log(this.cardDetails.likeStatus?.options);
              // for(let i in this.cardDetails.likeStatus.options) {
              //     console.log(this.cardDetails.likeStatus.options[i]-1);
              //     this.required = false;
              //     this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
              // }
              // this.dislikeForm.patchValue({
              //     firstName: this.user.firstname,
              //     lastName: this.user.lastname,
              //     email: this.user.email
              // });
              this.dislikeForm.patchValue({
                  firstName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.firstname!=null ? this.cardDetails.likeStatus.firstname: this.user.firstname,
                  lastName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.lastname!=null? this.cardDetails.likeStatus.lastname: this.user.lastname,
                  email: this.cardDetails.likeStatus && this.cardDetails.likeStatus.email!=null? this.cardDetails.likeStatus.email: this.user.email,
                  // reason:  this.cardDetails.likeStatus.options,
                  comment: this.cardDetails.likeStatus?this.cardDetails.likeStatus.comments:'',
                  notifyme: this.cardDetails.likeStatus?this.cardDetails.likeStatus.notifyme:'',
                  phone: this.cardDetails.likeStatus?this.cardDetails.likeStatus.phone:''
              });
          }
          else {
              if( this.cardDetails.likeStatus) {
                console.log(this.reason_array);
                  this.reasonArray();
                  this.clearFormArray(this.dislikeFormArray);
                  // this.dislikeReasons = this.cardDetails.likeStatus.options;
                 console.log(this.cardDetails.likeStatus.options);
                  for(let i in this.cardDetails.likeStatus.options) {
                      console.log(this.cardDetails.likeStatus.options[i]-1);
                      this.required = false;
                      this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
                      this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
                  }
                  if(this.cardDetails.likeStatus.flike) {
                      this.like=true;
                      this.dislike = false;
                  } else {
                      this.dislike=true;
                      this.like = false;
                  }
              }
                  // console.log(this.reason_array);
                  this.reasonArray();
                  this.dislikeForm.patchValue({
                      firstName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.firstname!=null ? this.cardDetails.likeStatus.firstname: this.user.firstname,
                      lastName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.lastname!=null? this.cardDetails.likeStatus.lastname: this.user.lastname,
                      email: this.cardDetails.likeStatus && this.cardDetails.likeStatus.email!=null? this.cardDetails.likeStatus.email: this.user.email,
                      // reason:  this.cardDetails.likeStatus.options,
                      comment: this.cardDetails.likeStatus?this.cardDetails.likeStatus.comments:'',
                      notifyme: this.cardDetails.likeStatus?this.cardDetails.likeStatus.notifyme:'',
                      phone: this.cardDetails.likeStatus?this.cardDetails.likeStatus.phone:''
                  });
          }
      // }, 100);
  }
  // On like button click
  likeClick() {

    // console.log(this.answerbyid.likestatus.flike)
    if(this.like==false)
      {


console.log(this.cardDetails)
console.log(this.answerbyid.likestatus)

     this.likePayload.answerid=this.cardDetails.id;
      // this.likePayload.commentby = "";
      // this.likePayload.commentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.likePayload.flike = true;
      console.log(this.likePayload.flike)
      // this.likePayload.id = this.cardDetails.likeStatus != null ? this.cardDetails.likeStatus.id : '';
console.log(this.likePayload)
console.log(this.answerbyid.likestatus)
      // this.likePayload.userId = 1;

          this.faqservice.likeArticle(this.likePayload).subscribe((data: any) => {
          console.log(data);
          if (data != null && data == true) {
            console.log("in like")
            this.answerbyid.likestatus = data;
              this.dislike=false;
              console.log(this.dislike)
              this.like=true;
              this.resetUnlikeForm();
              console.log(this.user.firstname)
              this.required = true;
              this.dislikeForm.patchValue({
                  firstName: this.user.firstname,
                  lastName: this.user.lastname,
                  email: this.user.email,
              });
              // setTimeout(function() {
              //     $(".faq-desc").trigger("click");
              // }, 3000);
          }
      });
    }

  }
  resetUnlikeForm(){
    this.reason_array = [];
    this.setReason();
    this.submitted = false;
    this.dislikeForm.reset();
    this.dislikeForm.controls['email'].setValidators([Validators.required, this.emailValidator()]);
    this.dislikeForm.controls['email'].updateValueAndValidity();

    this.dislikeForm.controls['phone'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(14)]);
    this.dislikeForm.controls['phone'].updateValueAndValidity();

    this.dislikeForm.get('reason').setValidators(Validators.required);
    this.dislikeForm.get('reason').updateValueAndValidity();
    // for(let i in data.likeStatus.options) {
    //     console.log('inside for');
    //     this.required = false;
    //     this.reason_array[data.likeStatus.options[i]-1].checked = true;
    // }
    const control = < FormArray > this.dislikeForm.controls['reason'];
    for (let i = control.length - 1; i >= 0; i--) {
        control.removeAt(i)
    }
}
commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
  const emails = control.value.split(',');
  const forbidden = emails.some(email => Validators.email(new FormControl(email)));
  //console.log(forbidden);
  if(forbidden==true)
  {
      this.mutlipleemail=true;
      //console.log(this.mutlipleemail);
  }
  else{
      this.mutlipleemail=false;

  }
  return forbidden ? { 'toaddr': { value: control.value } } : null;
};
sendArticleEmail() {
  this.emailFormSubmitted = true;
  // this.utilityService.checkLogin();
console.log(this.cardDetails.answeridobject.solution);
  if (this.emailFormData.value.toaddr!=null) {
    console.log("in email")

      this.emailFormData.controls['toaddr'].setValidators([Validators.required,this.commaSepEmail]);
      this.emailFormData.controls['toaddr'].updateValueAndValidity();
   }
   console.log(this.emailFormData.value.toaddr)

  if (this.emailFormData.invalid) {
      return;
  }

  console.log(this.cardDetails)
  console.log( this.emailFormData);
     // "body_html": "<p>Testing by sandeep</p>",
  // "to": [
  //   "sandeep.janumpally@nebulogic.com"
  // ],
  // "cc": [],
  // "subject": "Testing from CRM"
  //  }
  this.sendMailData.to = []; // Initialize it as an empty array
  this.sendMailData.to.push(this.emailFormData.value.toaddr);
  console.log()
  console.log( this.sendMailData.to.push(this.emailFormData.value.toaddr))
  this.sendMailData.to = [this.emailFormData.value.toaddr];
  this.sendMailData.cc=[this.emailFormData.value.ccaddr];
  this.sendMailData.subject = this.emailFormData.value.subject;
  this.sendMailData.body_html = this.cardDetails.answeridobject.solution;

  // this.sendMailData.templateName = "sharearticle";
  // this.sendMailDataPayload.articleID = this.cardDetails.id;
  // this.sendMailDataPayload.article = this.cardDetails.articledescriptionshort;
  // this.sendMailDataPayload.body_html = this.emailFormData.value.emailmsg;
  // this.sendMailData.payload = this.sendMailDataPayload;
  // this.sendMailData.attachmenturl = this.cardDetails.pdfurl.toString().trim();

  // this.sendMailData={
  //   "to":"pradeep.ciriguri@nebulogic.com,arunkanth.sunkara@nebulogic.com",
  //   "subject":"Sample Test",
  //   "templateName":"sharearticle",
  //   "payload":
  //       {
  //       "articleID": "RE001",
  //       "article": "How do I register for an account?",
  //       "shortdesc": "New Maine SMART CHSTS Portal users must send an email to the respective Maine CDC contact for new user registration.\n\n\n\nFor questions about newborn bloodspot, contact Anne Watson. Email: anne.watson@maine.gov, Ph: (207) 287-8188 \nFor questions about newborn hearing and/or audiology, contact Anne Banger. Email: anne.banger@maine.gov, Ph: (207)287-8427\nFor questions about birth defects, contact Anna Cyr. Email: anna.cyr@maine.gov, Ph: (207) 287-8424\n\n\nAfter the user has been restored within the portal, you will receive an email from support.mainechsts@nebulogic.com with login credentials and password reset information.\n"
  //    },
  //    "attachementurl":"https://nebulogic.com/old/NebuLogic-Corporate-Brochure.pdf"
  // };


  console.log(this.sendMailData);
  this.faqservice.sendEmailAttachment(this.sendMailData).subscribe(data => {
     // if (data == true) {
          var stringValue = data.toString();
          this.emailtexttoggle=JSON.parse(stringValue);
          $("#emailModal"+this.selectionType +" .close").trigger("click");
          $("#triggeremail"+this.selectionType).trigger("click");
      //}
  });
}

get eform() {
  return this.emailFormData.controls;
}
isSubmitDisabled() {
  return this.dislikeForm.invalid;
}
isSubmitDisabledemail() {
  return this.emailFormData.invalid;
}
closeResult = '';
open(content) {
  this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title'
  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
  } else {
      return `with: $ {
                reason
            }`;
  }
}
 // On reason checkbox change
 onChange(reason: string, isChecked: boolean) {
  // const reasonFormArray = < FormArray > this.dislikeForm.controls.reason;

  // if(isChecked) {
  //     reasonFormArray.push(new FormControl(reason));
  // } else {
  //     let index = reasonFormArray.controls.findIndex(x => x.value == reason)
  //     reasonFormArray.removeAt(index);
  // }
  // console.log(this.dislikeFormArray);
  // reasonFormArray.value.length == 0 ? this.required = true : this.required = false;

  if(isChecked) {
      this.dislikeFormArray.push(new FormControl(parseInt(reason)));
  } else {
      let index = this.dislikeFormArray.controls.findIndex(x => x.value == reason)
      this.dislikeFormArray.removeAt(index);
  }
  console.log(this.dislikeFormArray);
  console.log(this.dislikeForm.value);
  this.dislikeFormArray.value.length == 0 ? this.required = true : this.required = false;
}
reset() {
  // this.dislikeReasons = [];
  this.required = true;
  this.resetUnlikeForm();
}
// Reset unlike form

}
